export default __webpack_public_path__ + "static/media/oxford-campus.977b9a2d.jpg";